<template>
  <div class="container-md">
    <userHeader></userHeader>
    <router-view></router-view>
  </div>
</template>

<script>
import userHeader from '@/components/userInfo/header'
export default {
  name: "userPage",
  components: {userHeader}
}
</script>

<style scoped>
@media (min-width: 300px) and (max-width: 767px) {
  .h5-sor {
    font-size: 1.1rem;
  }

  .h5-sor small {
    font-size: 75%;
  }

  .account-info dt{
    /*-ms-flex: 0 0 28.333333%;*/
    /*flex: 0 0 28.333333%;*/
    /*max-width: 33.333333%;*/
  }

  .account-info > dt {
    padding-right: 0;
  }

  .account-info > dd {
    padding-left: 0;
    padding-right: 0;
  }

  .down-groups{
    font-size: .8rem;
  }
}

@media (min-width: 768px) {
  .h5-sor {
    font-size: 2rem;
  }

  .account-info {
    font-size: 1rem;
  }

  .account-info > dt {
    padding-right: 0;
  }

  .container-md {
    max-width: 960px;
  }
}
.container-md{
  min-height: 100vh;
}
</style>